import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { Civil3dPropertySetApiModel } from '../../../types/models/civil3d-property-set.model';
import { SearchCivil3dPropertySetsApiRequest } from '../../../types/requests/civil3d-property-sets/search-civil3d-property-sets.request';
import { GetCivil3dPropertySetApiRequest } from '../../../types/requests/civil3d-property-sets/get-civil3d-property-set.request';
import { DeleteCivil3dPropertySetApiRequest } from '../../../types/requests/civil3d-property-sets/delete-civil3d-property-set.request';
import { UpdateCivil3dPropertySetApiRequest } from '../../../types/requests/civil3d-property-sets/update-civil3d-property-set.request';
import { CreateCivil3dPropertySetApiRequest } from '../../../types/requests/civil3d-property-sets/create-civil3d-property-set.request';

export const createCivil3dPropertySet = ({ templateId, ...params }: CreateCivil3dPropertySetApiRequest) =>
  client.post<Civil3dPropertySetApiModel>(`/templates/${templateId}/civil3d/property-sets`, params);

export const updateCivil3dPropertySet = ({
  templateId,
  civil3dPropertySetId,
  ...params
}: UpdateCivil3dPropertySetApiRequest) =>
  client.patch<Civil3dPropertySetApiModel>(
    `/templates/${templateId}/civil3d/property-sets/${civil3dPropertySetId}`,
    params,
  );

export const getCivil3dPropertySet = <T extends Civil3dPropertySetApiModel>({
  civil3dPropertySetId,
  templateId,
  ...params
}: GetCivil3dPropertySetApiRequest) =>
  client.get<T>(`/templates/${templateId}/civil3d/property-sets/${civil3dPropertySetId}`, { params });

export const searchCivil3dPropertySets = <T extends Civil3dPropertySetApiModel>({
  templateId,
  ...params
}: SearchCivil3dPropertySetsApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/templates/${templateId}/civil3d/property-sets`, { params });

export const deleteCivil3dPropertySet = ({ templateId, civil3dPropertySetId }: DeleteCivil3dPropertySetApiRequest) =>
  client.delete<void>(`/templates/${templateId}/civil3d/property-sets`, {
    data: { civil3dPropertySetId },
  });
